import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material';
import * as _ from 'lodash';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { Socio, SociosEmpresa } from 'src/app/global/interfaces/datos-socios-empresa';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { Nacionalidad } from 'src/app/global/interfaces/nacionalidad';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { DatosSociosService } from 'src/app/global/services/datos-socios.service';
import { FlujosPaso2PJService } from 'src/app/global/services/flujos-paso-2-pj.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { datosPersonales } from 'src/app/messages/step-2-messages';
import { DialogServiceProvider } from 'src/app/view-model/providers/services/dialog/dialog.provider';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { correoValidator } from 'src/app/view-model/validators/correo.validator';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';
import { rutValidator } from 'src/app/view-model/validators/rut.validator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-datos-socio',
  templateUrl: './datos-socio.component.html',
  styleUrls: ['./datos-socio.component.scss'],
  providers: [DialogServiceProvider]
})
export class DatosSocioComponent {

  processing = false;
  private clickTimeout = null;
  cantidadRepresentantesMax = environment.numberPartners;

  // datos form valida ci
  formRut = 0;
  formRutControl: number;
  formSerieControl: string;
  respuestaAuthCI: GeneralResponse<any>;

  // Accordion and flow Controls
  ready = false;
  loading = false;
  dialog2doPlano = false;
  ciValidado = false;
  datosGuardados = false;
  validarSocio = true;
  agregandoSocio = false;
  contadorSociosIngresados = 0;
  listaRepresentantes: DatosPersonales[];
  edicion = true;
  formularioPrincipal = true;

  sociosEmpresa: SociosEmpresa;
  listaSociosEmpresa: Socio[];
  contadorSociosEmpresa = 0;
  socioSeleccionado: string = '';
  socioEvaluar: Socio;
  socioDos: Socio;

  socioPendiente: Socio;
  representanteAdmin: DatosPersonales;
  segundoRepresentante: DatosPersonales;
  panelOpenStateAdmin = false;
  panelOpenState = true;
  muestraEnAcordion = false;
  muestraSociosSelecionables = false;
  // Casos de socios
  dosSociosFC = false;
  tresSociosOMasFC = false;
  dosSociosOMasFI = false;
  unSocio = false;
  flujoNormal = false;
  bloqueaBotonGuardarSocio2 = true;
  okSocioDos = false;

  accordionSocios = true;
  visualizarEvaluacionAccordion = false;
  visualizarSocioDosAccordion = false;
  validacionSocioDos = false;
  procesoCompleto = true;
  //Mail de representante legal
  isThereAnEmailRRLL = false;

  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;
  nacionalidades: Nacionalidad[] = [];

  // get datos Socios handling vars
  isDatosPrecargados = false;
  datosPersonalesResponse: DatosPersonales;
  datosPersonalesAdminResponse: DatosPersonales;
  datosPersonalesSocioDosResponse: DatosPersonales;

  formChanged = false;

  @Input() showCantidadCampos = true;
  @Input() showInfoMessage = true;
  @Input() showInfoMessage2 = false;
  @Output() paso2Ok: EventEmitter<any> = new EventEmitter();

  public datosCiAccordionForm: FormGroup = this.authVmService.createSocioCIForm();
  public datosCiForm: FormGroup = this.authVmService.createSocioCIForm();
  public messageRescatarDataError = {
    serieSocio: [
      { type: 'required', message: step1Messages.REQUIRED_SERIE_MESSAGE },
      { type: 'serieLength', message: step1Messages.INVALID_SERIE_MESSAGE }
    ],
    rutSocio: [
      { type: 'required', message: step1Messages.REQUIRED_RUT_MESSAGE },
      { type: 'dniInvalid', message: step1Messages.INVALID_RUT_MESSAGE }
    ]
  };

  public datosSocioForm: FormGroup = new FormGroup({
    run: new FormControl('', [Validators.required, rutValidator]),
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', [Validators.nullValidator]),
    nacionalidad: new FormControl('0', [Validators.required, Validators.min(1)]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')]),
    correo: new FormControl('', this.isThereAnEmailRRLL ? [] : [correoValidator])
  });

  public datosSocioAdminForm: FormGroup = new FormGroup({
    run: new FormControl('', [Validators.required, rutValidator]),
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', [Validators.nullValidator]),
    nacionalidad: new FormControl('0', [Validators.required, Validators.min(1)]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')]),
    correo: new FormControl('', this.isThereAnEmailRRLL ? [] : [correoValidator])
  });

  public datosSocioDosForm: FormGroup = new FormGroup({
    run: new FormControl('', [Validators.required, rutValidator]),
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', [Validators.nullValidator]),
    nacionalidad: new FormControl('0', [Validators.required, Validators.min(1)]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')])
  });
  get flujos() {
    return this.flujosPaso2PJServ;
  }
  get flujo() {
    return this.flujosPaso2PJServ.datosSocio;
  }
  public mensajeErrorDatosPersonales = datosPersonales;

  constructor(
    private flujosPaso2PJServ: FlujosPaso2PJService,
    private storage: LocalStorageService,
    private datosPersonalesService: DatosPersonalesService,
    private dialogProv: DialogServiceProvider,
    private tagM: TagManagerService,
    private authVmService: AuthVMService,
    private dialogService: DialogService,
    private rutFormatter: RutFormatterService,
    private mkpRedirectService: MarketplaceRedirectService,
    private datosSociosService: DatosSociosService,
    private productService: vmProductosService,
  ) { }

  init() {
    this.obtieneListaSociosEmpresaAlInicio();
  }

  validaEdicion(): Promise<GeneralResponse<boolean>> {
    return new Promise((resolve, reject) => {
      const fnSuccess = (edicion: GeneralResponse<boolean>) => {
        resolve(edicion);
      };

      const fnFailure = (error) => {
        reject(error);
      };

      this.datosPersonalesService.validaEdicion().subscribe(fnSuccess, fnFailure);
    });
  }

  get calculaCantidadALlenar() {
    let cantidad = 2;
    const nombre = _.get(this.datosPersonalesResponse, 'nombre', null);
    const apellido1 = _.get(this.datosPersonalesResponse, 'apellidoPaterno', null);
    const nacionalidad = _.get(this.datosPersonalesResponse, 'idNacionalidad', null);
    cantidad += nombre === '' ? 1 : 0;
    cantidad += apellido1 === '' ? 1 : 0;
    cantidad += nacionalidad !== 47 ? 1 : 0;
    if (!this.isDatosPrecargados) {
      cantidad = 6;
    }
    return cantidad;
  }

  get rutControl(): FormControl {
    return this.datosCiForm.get('txtRut') as FormControl;
  }

  get serieControl(): FormControl {
    return this.datosCiForm.get('txtSerie') as FormControl;
  }

  get rutControlAccordion(): FormControl {
    return this.datosCiAccordionForm.get('txtRut') as FormControl;
  }

  get serieControlAccordion(): FormControl {
    return this.datosCiAccordionForm.get('txtSerie') as FormControl;
  }

  modalCiHelper(): void {
    const dialogRef = this.dialogService.openCiViewerDialog();
    dialogRef.afterClosed().subscribe();
  }

  validar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.onSubmitValidate();
      }, 100);
    }
  }

  async onSubmitValidate(): Promise<void> {
    let authResponse = null;
    let respuesta = null;
    try {
      this.loading = true;
      if (this.flujoNormal) {
        if (this.listaRepresentantes !== null && this.listaRepresentantes.length > 0) {
          const rutAEncontrar: number = this.rutFormatter.getRutFormats(this.datosCiForm.get('txtRut').value).numbers;
          const rutEncontrado = this.listaRepresentantes.find(x => x.run == String(rutAEncontrar));
          if (rutEncontrado !== undefined && rutEncontrado !== null && Number(rutEncontrado.run) > 0) {
            this.dialogService.openErrorDialog('Lo sentimos', 'No puedes repetir un RUT de un socio(a) ya registrado.<br><br>Por favor, intenta con otro.');
            this.datosCiForm = this.authVmService.createSocioCIForm();
            return;
          }
        }
      }

      if (this.validacionSocioDos) {
        authResponse = await this.validaCi(this.datosCiAccordionForm);
      } else {
        authResponse = await this.validaCi(this.datosCiForm);
      }
      // response handle

      if (_.get(authResponse, 'indicador', '') === 'OK') {
        if (this.validacionSocioDos) {
          this.validacionSocioDos = false;
          this.visualizarEvaluacionAccordion = false;
          this.visualizarSocioDosAccordion = true;
        }
        this.processing = false;
        this.ciValidado = true;
        this.showInfoMessage = false;
        this.showInfoMessage2 = true;
        this.getDatosPersonales();
      }
    } catch (exception) {
      if (this.validacionSocioDos) {
        //this.visualizarEvaluacionAccordion = true;
        //this.visualizarSocioDosAccordion = false;
        const loginAttemptsControl = this.datosCiAccordionForm.get('intentos');
        loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      } else {
        const loginAttemptsControl = this.datosCiForm.get('intentos');
        loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      }


      this.tagM.logError('Paso 1', _.get(exception, 'error.mensaje.titulo', ''), _.get(exception, 'error.message', ''));
      if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'se le han agotado los intentos')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
            this.mkpRedirectService.redirect();
          }
        });
      } else if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'NO_VIGENTE')) {

        if (this.validacionSocioDos) {
          if (this.datosCiAccordionForm.get('intentos').value === 2) {
            respuesta = this.dialogService.openInvalidSerieOfRutSecondAttemptDialog();
          } else if (this.datosCiAccordionForm.get('intentos').value === 1) {
            respuesta = this.dialogService.openInvalidSerieOfRutFirstAttemptDialog();
          }
        } else {
          if (this.datosCiForm.get('intentos').value === 2) {
            respuesta = this.dialogService.openInvalidSerieOfRutSecondAttemptDialog();
          } else if (this.datosCiForm.get('intentos').value === 1) {
            respuesta = this.dialogService.openInvalidSerieOfRutFirstAttemptDialog();
          }
        }
      } else if (_.includes(_.get(exception, 'error.indicador'), 'INTENTOS_AGOTADOS')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
            this.mkpRedirectService.redirect();
          }
        });
      } else {
        console.error(exception);
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
           return;
          }
        });
      }
    } finally {
      this.loading = false;
      this.processing = false;
    }
  }

  async validaCi(form: FormGroup): Promise<GeneralResponse<any>> {
    if (!form.valid) {
      throw new Error('form invalid');
    }

    const formCI = form.get('txtSerie');
    const formRut = form.get('txtRut').value;
    const rutInformation = this.rutFormatter.getRutFormats(formRut);
    const documentNumber = (formCI.value as string).replace(/\./g, '');
    this.formRut = rutInformation.numbers;
    this.formRutControl = this.formRut;
    this.formSerieControl = String(formCI.value).toUpperCase();

    const response: GeneralResponse<any> = await this.datosSociosService.validaCi(rutInformation.numbers, documentNumber).toPromise();
    this.respuestaAuthCI = response;
    if (response === null) {
      throw new Error('auth error');
    }
    if (response.indicador) {
      const loginAttemptsControl = form.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      switch (response.indicador) {
        case AUTH_INDICATOR.UNFINISHED_TRIP_BEFORE_42_DAYS: {
          this.authVmService.unfinishedTripBefore42DaysDialog();
          return;
        }
        case AUTH_INDICATOR.INTENTOS_AGOTADOS: {
          this.authVmService.bloquedAccountDialog(form);
          return;
        }
        case AUTH_INDICATOR.ERROR: {
          const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');
          if (intentosAgotados) {
            this.authVmService.bloquedAccountDialog(form);
          } else {
            this.authVmService.validarContenido(response, form);
          }
          return;
        }
      } // fin switch
      this.ciValidado = true;
      return response;
    } // fin if
  }

  async getDatosPersonales() {
    this.edicion = true;
    this.getNacionalidades(false);
  }

  functionNr1(): void {
    setTimeout(() => {
      this.processing = true;
      this.getDatosSocio(this.formRut);
    }, 5000);
  }

  getNacionalidades(nacionalidadDatosExistentes: boolean): void {
    this.processing = true;
    this.loading = true;
    const fnSuccess = (nacionalidades: Nacionalidad[]) => {
      this.nacionalidades = nacionalidades;
      if (!nacionalidadDatosExistentes) {
        this.getDatosSocio(this.formRut);
      }
      this.processing = false;
      this.loading = false;
    };

    const fnFailure = (error) => {
      console.error(error);
      this.error(error, () => this.getNacionalidades(false));
      this.tagM.logError('Paso 2', error.statusText, error.message);
    };

    this.datosPersonalesService.getNacionalidades().subscribe(fnSuccess, fnFailure);
  }

  partialResetDatosSocioForm(): void {
    this.datosSocioForm.get('nombre').reset();
    this.datosSocioForm.get('primerApellido').reset();
    this.datosSocioForm.get('segundoApellido').reset();
    this.datosSocioForm.get('telefono').reset();
    this.datosSocioForm.get('correo').reset();
  }

  partialResetDatosSocioDosForm(): void {
    this.datosSocioDosForm.get('nombre').reset();
    this.datosSocioDosForm.get('primerApellido').reset();
    this.datosSocioDosForm.get('segundoApellido').reset();
    this.datosSocioDosForm.get('telefono').reset();
    this.datosSocioDosForm.get('correo').reset();
  }

  getDatosSocio(rutSocio: number): void {
    this.processing = true;
    this.loading = true;
    const fnSuccess = (resp) => {
      if (resp != null) {
        if (this.datosPersonalesAdminResponse != undefined) {
          this.datosSocioAdminForm.get('nacionalidad').setValue(this.datosPersonalesAdminResponse.idNacionalidad);
        }
        this.partialResetDatosSocioForm();
        this.isDatosPrecargados = true;
        if (this.visualizarSocioDosAccordion) {
          this.datosPersonalesSocioDosResponse = resp as DatosPersonales;
          const runFormateadoPuntoGuion = this.rutFormatter.format(this.datosPersonalesSocioDosResponse.run + '' + this.rutFormatter.getDv(Number(this.datosPersonalesSocioDosResponse.run)));
          this.agregaValoresFormulario(this.datosSocioDosForm, runFormateadoPuntoGuion, false, this.datosPersonalesSocioDosResponse, false, false);
        } else {
          this.datosPersonalesResponse = resp as DatosPersonales;
          const runFormateadoPuntoGuion = this.rutFormatter.format(this.datosPersonalesResponse.run + '' + this.rutFormatter.getDv(Number(this.datosPersonalesResponse.run)));
          this.agregaValoresFormulario(this.datosSocioForm, runFormateadoPuntoGuion, false, this.datosPersonalesResponse, true, false);
        }
      } else {
        if(this.validacionSocioDos){
          this.partialResetDatosSocioDosForm();
          this.datosPersonalesSocioDosResponse = null;
          this.isDatosPrecargados = false;
          this.datosSocioDosForm.get('run').setValue(this.rutFormatter.format(rutSocio + '' + this.rutFormatter.getDv(Number(rutSocio))));
          this.matExpansion.open();
        }else{
          this.partialResetDatosSocioForm();
          this.datosPersonalesResponse = null;
          this.datosSocioForm.get('run').setValue(this.rutFormatter.format(rutSocio + '' + this.rutFormatter.getDv(Number(rutSocio))));
          this.matExpansion.open();
          this.panelOpenState = true;
        }
      }
      this.processing = false;
      this.loading = false;
    };

    const fnFailure = error => {
      console.error(error);
      this.error(error, () => this.getDatosSocio(this.formRut));
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.functionNr1();
    };
    // Obtener el rut desde el paso 1 (puede ser por un @Input)
    this.datosSociosService.getDatosPersonales(rutSocio).subscribe(fnSuccess, fnFailure);
  }

  error(error, callback: Function) {
    // this.showErrorDialog(error.statusText, error.message, () => callback());
    if (error.error.indicador === 'PROCESO_SEGUNDO_PLANO') {
      this.dialogProv.openEnSegundoProcesoDialog();
    } else {
      this.showErrorDialog(error.statusText, error.message, () => callback());
    }
  }

  showErrorDialog(title: string, message: string, callback: Function) {
    this.dialogProv.openErrorDialog(title, message).afterClosed()
      .subscribe((data) => {
        callback();
      });
  }

  Guardar(): void {
    if (this.dosSociosFC) {
      this.accordionSocios = true;
      this.datosCiAccordionForm.get('txtRut').setValue(this.socioPendiente.run + "-" + this.rutFormatter.getDv(Number(this.socioPendiente.run)));
      this.visualizarEvaluacionAccordion = true;
      this.muestraEnAcordion = true;
      this.panelOpenState = true;
      this.getDatosSocioAdmin(this.formRut);
      this.loading = false;
    }else if(this.unSocio){
      this.accordionSocios = true;
      this.muestraEnAcordion = true;
    }else if(this.dosSociosOMasFI){
      this.accordionSocios = true;
      this.muestraEnAcordion = true;
      this.getDatosSocioAdmin(this.formRut);
    }
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraDatos(false);
      }, 100);
    }
  }

  async registraDatos(socioDos: boolean) {

    this.loading = true;
    let datos: DatosPersonalesRequest;
    if (this.visualizarSocioDosAccordion) {
      datos = {
        run: this.rutFormatter.getRutFormats(this.datosSocioDosForm.get('run').value).numbers,
        nombres: {
          nombres: this.datosSocioDosForm.get('nombre').value,
          apellidoPaterno: this.datosSocioDosForm.get('primerApellido').value,
          apellidoMaterno: this.datosSocioDosForm.get('segundoApellido').value
        },
        idNacionalidad: Number(this.datosSocioDosForm.get('nacionalidad').value),
        telefono: Number(this.datosSocioDosForm.get('telefono').value)
      };
    } else {
      datos = {
        run: this.rutFormatter.getRutFormats(this.datosSocioForm.get('run').value).numbers,
        nombres: {
          nombres: this.datosSocioForm.get('nombre').value,
          apellidoPaterno: this.datosSocioForm.get('primerApellido').value,
          apellidoMaterno: this.datosSocioForm.get('segundoApellido').value
        },
        idNacionalidad: Number(this.datosSocioForm.get('nacionalidad').value),
        telefono: Number(this.datosSocioForm.get('telefono').value),
        correo: this.datosSocioForm.get('correo').value
      };
    }

    const fnSuccess = async (resp) => {
      if (resp != null) {
        this.datosCiForm = this.authVmService.createSocioCIForm();
        this.obtienesRepresentantes();
      }
      if (socioDos) {
        this.matExpansion.close();
        this.okSocioDos = true;
        this.panelOpenState = false;
      }
      this.datosGuardados = true;
      this.ciValidado = false;
      this.loading = false;
      this.processing = false;
      if(!this.dosSociosFC || this.flujoNormal && !socioDos ){
        this.bloqueaBotonGuardarSocio2 = false;
      }else{
        this.bloqueaBotonGuardarSocio2 = true;
      }
   
    };

    const fnFailure = (error) => {
      this.bloqueaBotonGuardarSocio2 = false;
      console.error(error);
      this.loading = false;
      this.error(error, () => this.registraDatos(false));
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.processing = false;
    };

    this.datosSociosService.registraDatosPersonales(datos).subscribe(fnSuccess, fnFailure);
  }

  async obtienesRepresentantes() {
    this.processing = true;
    this.loading = true;
    const fnSuccess = async (resp) => {
      if (resp != null) {
        this.listaRepresentantes = resp as DatosPersonales[];
        this.contadorSociosIngresados = this.listaRepresentantes.length;
        if (this.contadorSociosIngresados <= 0) {
          this.flujosPaso2PJServ.datosSocio.ok = false;
          this.flujosPaso2PJServ.datosAdjuntos.ok = false;
          this.flujosPaso2PJServ.datosAdjuntos.cargando = false;
          this.flujosPaso2PJServ.datosAdjuntos.bloqueado = true;
          this.validarSocio = true;
        } else {
          this.validarSocio = false;
        }
        this.agregandoSocio = false;
        this.checkIfMailIsNeeded();
        this.storage.addPaso2({ datosSocios: this.listaRepresentantes });
      }
      if(this.dosSociosOMasFI){
        this.validarSocio = false;
      }
      this.loading = false;
      this.processing = false;
      this.flujosPaso2PJServ.datosSocio.cargando = false;
      this.matExpansion.open();
    };

    const fnFailure = (error) => {
      console.error(error);
      this.error(error, () => this.obtienesRepresentantes());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.loading = false;
      this.processing = false;
    };

    this.datosSociosService.getSociosRegistrados().subscribe(fnSuccess, fnFailure);
  }

  AgregarOtroSocio(): void {
    this.validarSocio = true;
    this.agregandoSocio = true;
  }

  ObtieneListaRespresentatesInicio(): void {
    if (!(this.processing)) {
      this.processing = true;
      this.loading = true;
      this.clickTimeout = setTimeout(() => {
        this.obtienesRepresentantesAlInicio();
      }, 100);
    }
  }

  async obtienesRepresentantesAlInicio() {
    this.processing = true;
    this.loading = true;

    const fnSuccess = async (resp) => {
      this.loading = false;
      this.processing = false;
      this.flujosPaso2PJServ.datosSocio.cargando = false;
      if (resp != null) {
        this.listaRepresentantes = resp as DatosPersonales[];
        this.contadorSociosIngresados = this.listaRepresentantes.length;
        if (this.contadorSociosIngresados > 0 && this.contadorSociosIngresados <= this.cantidadRepresentantesMax) {
          this.validarSocio = false;
          // si el flujo es normal desaciva la visualizacion de validacion de socios y se visualiza agregar socio con el panel cerrado
          if (this.flujoNormal) {
            this.accordionSocios = false;
            // validar socio se inicializo en true
            this.agregandoSocio = false;
            this.matExpansion.close();
            this.Continuar();
          } else if (this.dosSociosFC) {
            this.flujoDosSocios();
          } else if (this.unSocio) {
            this.flujoUnSocio();
          } else if (this.dosSociosOMasFI) {
            this.flujoDosSociosOMasFI();
          }
        } else {
          if (this.dosSociosFC || this.dosSociosOMasFI) {
            this.accordionSocios = false;
            this.muestraSociosSelecionables = true;
            this.bloqueaBotonGuardarSocio2 = false;
            this.procesoCompleto = false;
          } else if (this.unSocio) {
            this.accordionSocios = false;
            this.socioEvaluar = this.listaSociosEmpresa[0];
            this.datosCiForm.get('txtRut').setValue(this.socioEvaluar.run + "-" + this.rutFormatter.getDv(Number(this.socioEvaluar.run)));
            this.procesoCompleto = false;
          }
        }
        if (this.flujoNormal) {
          this.checkIfMailIsNeeded();
          this.procesoCompleto = false;
        } else if (this.dosSociosFC || this.dosSociosOMasFI) {
          this.validarSocio = false;
        }
        this.storage.addPaso2({ datosSocios: this.listaRepresentantes });
      }
    };

    const fnFailure = (error) => {
      console.error(error);
      this.error(error, () => this.obtienesRepresentantes());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.loading = false;
      this.processing = false;
    };

    this.datosSociosService.getSociosRegistrados().subscribe(fnSuccess, fnFailure);
  }

  checkIfMailIsNeeded() {
    this.isThereAnEmailRRLL = this.listaRepresentantes.some(rl => rl.correo != null);
    this.isThereAnEmailRRLL ? this.datosSocioForm.get("correo").clearValidators() : this.datosSocioForm.get("correo").setValidators(correoValidator);
  }

  Continuar() {
    this.loading = true;
    if (!this.processing && this.contadorSociosIngresados > 0) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraSeleccionProducto();
        try {
          const _edicion = this.validaEdicion();
          if (!_edicion) {
            this.flujosPaso2PJServ.setEdicionFalse();
          }
        } catch (e) { }

        // Se elimina porque no se necesita validar completitud de pasos posteriores cuando el paso se ha validado asi mismo
        //if (this.flujosPaso2PJServ.configuracionProducto.ok) {
        this.ready = true;
        this.flujosPaso2PJServ.datosSocio.ok = true;
        this.paso2Ok.emit();
        this.tagM.logDL_datosSocios();
        

        this.matExpansion.close();
        this.loading = false;
        this.processing = false;
      }, 100);
    }
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (e) {
      console.error('SELECCION PRODUCTO:', e);
    }
  }

  Eliminar(runSocio: number): void {
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.eliminarRegistro(runSocio);
      }, 100);
    }
  }

  eliminarRegistro(runSocio: number) {
    this.loading = true;
    this.datosSociosService.eliminarRegistro(runSocio).subscribe(resp=> {
      if (resp != null) {
        this.obtienesRepresentantes();
      }
      this.ciValidado = false;
      this.loading = false;
      this.processing = false;
      },
      error => {
        console.error(error);
        this.loading = false;
        this.error(error, () => this.eliminarRegistro(runSocio));
        this.tagM.logError('Paso 2', error.statusText, error.message);
        this.processing = false;
      }
    );
  }

  async modalEliminarSocio(representante: DatosPersonales) {
    const nombreSocio = representante.nombre.nombres + ' ' + representante.nombre.apellidoPaterno + ' ' + representante.nombre.apellidoMaterno;
    const data = {
      title: 'Eliminar socio(a)',
      description: '<strong>¿Está seguro que deseas eliminar al socio(a) ' + nombreSocio + '?</strong> <br><br> Esta acción no se puede deshacer. Si eliminas el socio(a), deberás ingresar los datos de la nueva persona que quieres asignar.',
      cancelButton: 'No, regresar',
      actionButton: 'Sí, eliminar'
    };
    this.dialogService.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
      if (action.action === 'OK') {
        await this.Eliminar(Number(representante.run));
        this.edicion = await (await this.validaEdicion()).data;
      }
    });
  }

  async obtieneListaSociosEmpresaAlInicio() {
    if (!(this.processing)) {
      this.loading = true;
      this.clickTimeout = setTimeout(() => {
        this.obtieneSociosEmpresa();
      }, 100);
    }
  }

  async obtieneSociosEmpresa() {
    this.processing = true;
    this.loading = true;
    this.flujosPaso2PJServ.datosAdjuntos.bloqueado = false;
    this.datosSociosService.getSociosEmpresa().subscribe(resp => {

      this.loading = false;
      this.processing = false;
      this.flujosPaso2PJServ.datosSocio.cargando = false;
      if (resp != null) {
        this.sociosEmpresa = resp.data as SociosEmpresa;
        this.listaSociosEmpresa = this.sociosEmpresa.socios;
        this.contadorSociosEmpresa = this.sociosEmpresa.socios.length;
        this.validacionDeCasos(this.contadorSociosEmpresa, this.sociosEmpresa.firmaConjunta, this.sociosEmpresa.empresaEnUnDia, this.sociosEmpresa.poderComplejo);
      }else{
        this.flujoNormal = true;
      }
      this.ObtieneListaRespresentatesInicio();
    },
      error => {
        console.error(error);
        this.error(error, () => this.obtieneSociosEmpresa());
        this.tagM.logError('Paso 2', error.statusText, error.message);
        this.loading = false;
        this.processing = false;
      });
  }

  validacionDeCasos(contadorSociosEmpresa: number, conjuntamente: boolean, empresaEnUnDia: boolean, poderComplejo: boolean) {
    if (contadorSociosEmpresa == 0 || !empresaEnUnDia || poderComplejo ) {
      this.flujoNormal = true;
    } else if (contadorSociosEmpresa == 2 && conjuntamente) {
      this.dosSociosFC = true;
    } else if (contadorSociosEmpresa == 1) {
      this.unSocio = true;
    } else if (contadorSociosEmpresa > 2 && conjuntamente) {
      this.tresSociosOMasFC = true;
    } else if (contadorSociosEmpresa >= 2 && !conjuntamente) {
      this.dosSociosOMasFI = true;
    } else {
      this.flujoNormal = true;
    }
  }

  actualizarSocioSeleccionado(socioSeleccionado: any) {
    this.socioSeleccionado = socioSeleccionado;
    this.socioEvaluar = this.listaSociosEmpresa[socioSeleccionado - 1];
    if(!this.dosSociosOMasFI){
      if (socioSeleccionado == 1) {
        this.socioPendiente = this.listaSociosEmpresa[1];
      } else if (socioSeleccionado == 2) {
        this.socioPendiente = this.listaSociosEmpresa[0];
      }
    }
  }

  irAEvaluacion() {
    this.muestraSociosSelecionables = false;
    this.validarSocio = true;
    this.datosCiForm.get('txtRut').setValue(this.socioEvaluar.run + "-" + this.rutFormatter.getDv(Number(this.socioEvaluar.run)));
  }

  getDatosSocioAdmin(rutSocio: number): void {
    const fnSuccess = (resp) => {
      if (resp != null) {
        this.partialResetDatosSocioAdminForm();
        this.isDatosPrecargados = true;
        this.datosPersonalesAdminResponse = resp as DatosPersonales;
        const runFormateadoPuntoGuion = this.rutFormatter.format(this.datosPersonalesAdminResponse.run + '' + this.rutFormatter.getDv(Number(this.datosPersonalesAdminResponse.run)));
        this.agregaValoresFormulario(this.datosSocioAdminForm, runFormateadoPuntoGuion, true, this.datosPersonalesAdminResponse, true, false);
      } else {
        this.partialResetDatosSocioAdminForm();
        this.datosPersonalesAdminResponse = null;
        this.isDatosPrecargados = false;
        this.datosSocioAdminForm.get('run').setValue(this.rutFormatter.format(rutSocio + '' + this.rutFormatter.getDv(Number(rutSocio))));
      }
      this.processing = false;
      this.loading = false;
    };

    const fnFailure = error => {
      console.error(error);
      this.error(error, () => this.getDatosSocioAdmin(this.formRut));
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.functionNr1();
    };
    // Obtener el rut desde el paso 1 (puede ser por un @Input)
    this.datosSociosService.getDatosPersonales(rutSocio).subscribe(fnSuccess, fnFailure);
  }

  partialResetDatosSocioAdminForm(): void {
    this.datosSocioAdminForm.get('nombre').reset();
    this.datosSocioAdminForm.get('primerApellido').reset();
    this.datosSocioAdminForm.get('segundoApellido').reset();
    this.datosSocioAdminForm.get('telefono').reset();
    this.datosSocioAdminForm.get('correo').reset();
  }

  agregaValoresFormulario(form: FormGroup, runFormateadoPuntoGuion: string, formularioAdmin: boolean, datosPersonalesResponse: DatosPersonales, tieneCorreo: boolean, datosDesdeSocioRegistrado: boolean) {
    form.get('run').setValue(runFormateadoPuntoGuion);
    form.get('nombre').setValue(datosPersonalesResponse.nombre.nombres);
    form.get('primerApellido').setValue(datosPersonalesResponse.nombre.apellidoPaterno);
    form.get('segundoApellido').setValue(datosPersonalesResponse.nombre.apellidoMaterno);
    if (datosPersonalesResponse.idNacionalidad) {
      form.get('nacionalidad').setValue(datosPersonalesResponse.idNacionalidad);
    } else {
      form.get('nacionalidad').setValue(0);
    }
    if (formularioAdmin) {
      if (datosDesdeSocioRegistrado) {
        this.datosSocioAdminForm.get('telefono').setValue(datosPersonalesResponse.telefono);
        this.datosSocioAdminForm.get('correo').setValue(datosPersonalesResponse.correo);
        this.datosPersonalesAdminResponse = { nombre: datosPersonalesResponse.nombre, idNacionalidad: datosPersonalesResponse.idNacionalidad };
      } else {
        this.datosSocioAdminForm.get('telefono').setValue(this.datosSocioForm.get('telefono').value);
        this.datosSocioAdminForm.get('correo').setValue(this.datosSocioForm.get('correo').value);
      }

    } else {
      form.get('telefono').setValue(datosPersonalesResponse.telefono);
      if (tieneCorreo) {
        form.get('correo').setValue(datosPersonalesResponse.correo);
      }
    }
    if (form.valid) {
      this.flujosPaso2PJServ.datosAdjuntos.bloqueado = false;
    } else {
      this.matExpansion.open();
      this.dialogProv.closeProcesoSegundoPlanoDialog();
    }
  }

  validarSocioDos($event: any) {
    this.validacionSocioDos = true;
    this.bloqueaBotonGuardarSocio2 = false;
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores

    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.onSubmitValidate();
      }, 100);
    }
  }

  GuardarSocio2(): void {
    this.bloqueaBotonGuardarSocio2 = true;
    this.loading = false;
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraDatos(true);
      }, 100);
    }
  }

  buscaExistenciaSociosRegistrados() {
    let existenSociosRegistrados = true;
    this.listaRepresentantes.forEach(representante => {
      if (existenSociosRegistrados) {
        existenSociosRegistrados = this.listaSociosEmpresa.some(soc => soc.run == representante.run);
      }
    });
    return existenSociosRegistrados;
  }

  eliminaTodosSociosRegistrados(): void {
    this.listaRepresentantes.forEach(rep => {
      this.eliminarRegistro(Number(rep.run));
    });
  }

  flujoDosSocios(): void {
    this.panelOpenStateAdmin = false;
    // si no es el flujo normal se valida que existen los representantes registrados en la lista de socios de nuevo servicio
    const sociosRegistrados = this.buscaExistenciaSociosRegistrados();
    if (!sociosRegistrados) {
      // elimina todos los socios registrados
      this.accordionSocios = false;
      this.eliminaTodosSociosRegistrados();
      this.muestraSociosSelecionables = true;
      this.procesoCompleto = false;
    } else {
      this.bloqueaBotonGuardarSocio2 = true;
      this.accordionSocios = true;
      this.muestraEnAcordion = true;
      this.getNacionalidades(true);
      // identifica cual es el socio administrador que tiene el mail
      if (this.contadorSociosIngresados == 1) {
        this.representanteAdmin = this.listaRepresentantes[0];
        this.listaSociosEmpresa.forEach(socio => {
          this.listaRepresentantes.forEach(rep => {
            const nombre = rep.nombre.nombres + " " + rep.nombre.apellidoPaterno + " " + rep.nombre.apellidoMaterno;
            if (rep.correo != null && rep.run == socio.run) {
              this.socioEvaluar = { nombre: nombre };
            } else {
              this.socioPendiente = { nombre: socio.nombre, run: socio.run };
            }
          });
        });
        // se visualiza evaluacion de socio 2
        this.visualizarEvaluacionAccordion = true;
        // se setea el rut a socio 2
        this.datosCiAccordionForm.get('txtRut').setValue(this.socioPendiente.run + "-" + this.rutFormatter.getDv(Number(this.socioPendiente.run)));
        this.bloqueaBotonGuardarSocio2 = false;
        this.procesoCompleto = false;
      } else {
        this.listaSociosEmpresa.forEach(socio => {
          this.listaRepresentantes.forEach(rep => {
            const nombre = rep.nombre.nombres + " " + rep.nombre.apellidoPaterno + " " + rep.nombre.apellidoMaterno;
            if (rep.correo != null && rep.run == socio.run) {
              this.socioEvaluar = { nombre: nombre };
            } else if (rep.correo == null && rep.run == socio.run) {
              this.socioPendiente = { nombre: socio.nombre, run: socio.run };
            }
          });
        });
        this.listaRepresentantes.forEach(rep => {
          if (rep.correo != null) {
            this.representanteAdmin = rep;
            const nombre = this.representanteAdmin.nombre.nombres + " " + this.representanteAdmin.nombre.apellidoPaterno + " " + this.representanteAdmin.nombre.apellidoMaterno;
            this.socioEvaluar = { nombre: nombre };
          } else {
            this.segundoRepresentante = rep;
            const nombre = this.segundoRepresentante.nombre.nombres + " " + this.segundoRepresentante.nombre.apellidoPaterno + " " + this.segundoRepresentante.nombre.apellidoMaterno;
            this.socioPendiente = { nombre: nombre };

            const runFormateadoPuntoGuion = this.rutFormatter.format(this.segundoRepresentante.run + '' + this.rutFormatter.getDv(Number(this.segundoRepresentante.run)));
            this.agregaValoresFormulario(this.datosSocioDosForm, runFormateadoPuntoGuion, false, this.segundoRepresentante, false, true);
            this.visualizarSocioDosAccordion = true;
          }
        });
        this.matExpansion.close();
        this.okSocioDos = true;
        this.panelOpenState = false;
        this.processing = false;
        this.Continuar();
      }
      const runFormateadoPuntoGuion = this.rutFormatter.format(this.representanteAdmin.run + '' + this.rutFormatter.getDv(Number(this.representanteAdmin.run)));
      this.agregaValoresFormulario(this.datosSocioAdminForm, runFormateadoPuntoGuion, true, this.representanteAdmin, true, true);
    }
  }

  flujoUnSocio(): void {
    this.getNacionalidades(true);
    this.socioEvaluar = this.listaSociosEmpresa[0];
    if (this.listaSociosEmpresa.length < this.listaRepresentantes.length) {
      this.eliminaTodosSociosRegistrados();
      this.datosCiForm.get('txtRut').setValue(this.socioEvaluar.run + "-" + this.rutFormatter.getDv(Number(this.socioEvaluar.run)));
      this.validarSocio = true;
      this.procesoCompleto = false;
    } else {
      // Busca si el socio registrado es igual al socio obtenido desde servicio
      const sociosRegistrados = this.buscaExistenciaSociosRegistrados();
      if (!sociosRegistrados) {
        // elimina todos los socios registrados
        this.accordionSocios = false;
        this.eliminaTodosSociosRegistrados();
        this.validarSocio = true;
        this.datosCiForm.get('txtRut').setValue(this.socioEvaluar.run + "-" + this.rutFormatter.getDv(Number(this.socioEvaluar.run)));
        this.procesoCompleto = false;
      } else {
        this.validarSocio = false;
        this.accordionSocios = true;
        this.representanteAdmin = this.listaRepresentantes[0];
        const runFormateadoPuntoGuion = this.rutFormatter.format(this.representanteAdmin.run + '' + this.rutFormatter.getDv(Number(this.representanteAdmin.run)));
        this.agregaValoresFormulario(this.datosSocioAdminForm, runFormateadoPuntoGuion, true, this.representanteAdmin, true, true);
        this.muestraEnAcordion = true;
        this.procesoCompleto = false;
      }
    }
  }

  flujoDosSociosOMasFI():void{
    if (this.listaRepresentantes.length > 1) {
      this.eliminaTodosSociosRegistrados();
      this.muestraSociosSelecionables = true;
      this.procesoCompleto = false;
    } else {
      // Busca si el socio registrado es igual al socio obtenido desde servicio
      const sociosRegistrados = this.buscaExistenciaSociosRegistrados();
      if (!sociosRegistrados) {
        // elimina todos los socios registrados
        this.accordionSocios = false;
        this.eliminaTodosSociosRegistrados();
        this.validarSocio = false;
        this.muestraSociosSelecionables = true;
        //this.datosCiForm.get('txtRut').setValue(this.socioEvaluar.rut + "-" + this.rutFormatter.getDv(Number(this.socioEvaluar.rut)));
        this.procesoCompleto = false;
      } else {
        this.Continuar();
        this.ciValidado = true;
        this.listaRepresentantes.forEach(resp => {
          this.listaSociosEmpresa.forEach(soc=>{
            if(resp.run == soc.run){
              this.socioEvaluar = soc
            }
          })
        });
        this.getNacionalidades(true);
        this.validarSocio = false;
        this.accordionSocios = true;
        this.formularioPrincipal = false;
        this.representanteAdmin = this.listaRepresentantes[0];
        const runFormateadoPuntoGuion = this.rutFormatter.format(this.representanteAdmin.run + '' + this.rutFormatter.getDv(Number(this.representanteAdmin.run)));
        this.agregaValoresFormulario(this.datosSocioAdminForm, runFormateadoPuntoGuion, true, this.representanteAdmin, true, true);
        this.muestraEnAcordion = true;
      }
    }
  }

  ContinuarADeclaracion():void{
    this.matExpansion.close();
    this.panelOpenStateAdmin = false;
    this.processing = false;
    this.Continuar();
  }
  ContinuarDosSocios():void{
    this.processing = false;
    this.Continuar();
  }

  CambiarSocio():void{
    this.datosCiForm.get('txtSerie').reset();
    this.muestraSociosSelecionables = true;
    this.validarSocio = false;
    this.ciValidado = false;
    this.showInfoMessage = true;
  }
}
